import Api from '~/store/idonia-api/api'
import bus from '~/bus'
export function useWhatsApp (store, t) {
  function showOptinDialog (store, t, callbackf, ...args) {
    if (store.state.dialog.dialog.title && store.state.dialog.dialog.title.name === 'dialog-share-file-header') {
      store.dispatch('dialog/setProps', Object.assign(store.state.dialog.dialog.props || {}, {videoExists: true}))
    }
    return new Promise((resolve, reject) => {
      store.dispatch('dialog/unshiftDialog', {
        title: t('Whatsapp Consent'),
        body: require('~/components/common/dialog/types/DialogWhatsappOptIn.vue').default,
        width: 800,
        persistent: true,
        scrollable: true,
        props: { callback: () => {
          callbackf(...args)
          resolve(true)
        } },
        actions: {
          accept: {
            title: t('Accept'),
            callback: () => {
              callbackf(...args)
              resolve(true)
            }
          },
          cancel () {
            reject(new Error('no consent given'))
          }
        }
      })
    }).finally(() => {
      bus.$emit('reloadAccountInfo')
    })
  }

  function checkIfSigned () {
    return Api.getV2('account/contracts').then((response) => {
      return !!(response.body && response.body.findIndex(e => e.name === 'whatsapp_opt_in') > -1)
    }).catch(e => console.error((e)))
  }
  function sendWhatsappNotification (fileID) {
    return new Promise((resolve, reject) => {
      checkIfSigned().then(response => {
        if (response) {
          return Api.postV2('file/whatsapp/' + fileID, { ui_url: window.location.origin }).then((response) => {
            if (response.status === 200 && response.ok) {
              resolve(response)
            } else reject(response)
          }).catch(e => {
            reject(e)
          })
        } else {
          store.dispatch('dialog/setProps', Object.assign(store.state.dialog.dialog.props || {}, {videoId: fileID}))
          showOptinDialog(store, t, () => {
            sendWhatsappNotification(fileID)
          })
        }
      }).catch(e => console.error(e))
    })
  }
  const allowedExtensions = ['mp4', 'jpg', 'jpeg', 'png', 'amr', 'pdf'] // 'mp3','ogg', not well supported by twilio
  return {
    checkIfSigned,
    showOptinDialog,
    sendWhatsappNotification,
    allowedExtensions

  }
}



// WEBPACK FOOTER //
// ./src/commons/whatsapp.js